import create from 'zustand';
import produce from 'immer';

const DOCUMENT_CREATE_INITIAL = {
	document: {
		title: '',
		type: '',
		teacher: false,
		student: false,
		parent: false,
		grades: [],
		courses: []
	}
};

export const useDocumentCreateStore = create(set => ({
	...DOCUMENT_CREATE_INITIAL,

	// Handle state change
	onChange: ({ name, value }) => set(produce(state => {
		state.document[name] = value;
	})),

	// Handle document's grade addition
	onAddGrade: (grade) => set(produce(state => {
		state.document.grades.push(grade);
	})),

	// Handle document's grade removal
	onRemoveGrade: (id) => set(produce(state => {
		state.document.grades = state.document.grades.filter(grade => grade.id !== id);
	})),

	// Handle document's course addition
	onAddCourse: (course) => set(produce(state => {
		state.document.courses.push(course);
	})),

	// Handle document's course removal
	onRemoveCourse: (id) => set(produce(state => {
		state.document.courses = state.document.courses.filter(course => course.id !== id);
	})),

	// Reset store to initial state
	onReset: () => set({
		...DOCUMENT_CREATE_INITIAL
	})
}));